<template>
  <div>
    <!-- Three.js Container for the rotating cube -->
    <div id="three-container" class="three-container"></div>

    <!-- Main Content -->
    <div class="home-content" :class="{ blur: showGame }">
    <br>
      <h1 class="title">____________ iChrispin Diary</h1>
      <br>
      <br>
      <br>
      <p class="intro">Explore romantic poems, engaging stories, and interactive content that will brighten your day!</p>
       </div>

    <!-- Additional Three.js Container for interactive scene -->
    <div id="three-container-extra" class="three-container-extra">
    <br>
    <br>
    </div>

<!-- Game Area -->
<div v-if="showGame" class="game-area box">
  <div class="buttons is-left">
    <button @click="closeGame" class="button is-danger close-game-button">Close Game</button>
    <button @click="checkSolution" class="button is-success check-button">Check</button>
  </div>
  <div v-if="showInstructions" class="instructions has-text-centered">
    <p>Drag and drop the letters to solve the puzzle!</p>
  </div>
  <div class="puzzle">
    <div v-for="(letter, index) in shuffledLetters" :key="index" class="puzzle-piece" :style="{ left: `${(index % 3) * 100}px`, top: `${Math.floor(index / 3) * 100}px` }" @mousedown="startDrag($event, index)">
      {{ letter }}
    </div>
  </div>
  <p v-if="feedbackMessage" class="feedback-message has-text-centered">{{ feedbackMessage }}</p>
  <div v-if="showPoem" class="poem-modal">
    <div class="poem-content">
      <p>{{ poem }}</p>
      <button @click="closePoem" class="button is-danger close-button">Close</button>
    </div>
  </div>
</div>
  </div>
</template>

<script>
import * as THREE from 'three';

export default {
  name: 'HomePage',
  data() {
    return {
      letters: ['C', 'H', 'R', 'I', 'S', 'P', 'I', 'N'],
      shuffledLetters: [],
      showGame: false,
      feedbackMessage: '',
      dragStartIndex: null,
      currentDragIndex: null,
      puzzlePositions: [],
      isDragging: false,
      showPoem: false,
      showInstructions: true,
      poem: '',
      poems: [
        'You are destined for greatness,\nI, Chrispin, pen it down,\nWith every step you take,\nWear your success like a crown.\n\nBright future lies ahead,\nKeep pushing through the strife,\nFor every dream you cherish,\nWill surely come to life.',
        'In every heart there’s courage,\nTo face each passing day,\nAnd with determination,\nYou’ll find a brighter way.\n\nSo trust in your endeavors,\nAnd let your spirit soar,\nFor endless opportunities,\nAre knocking at your door.',
        'The world is full of wonders,\nFor those who seek to find,\nThe beauty in the journey,\nAnd treasures of the mind.\n\nEmbrace the path before you,\nWith hope and fearless stride,\nFor fortune favors those,\nWho walk with love and pride.',
        'In the tapestry of life,\nYour thread is bold and bright,\nWeaving tales of triumph,\nThrough every day and night.\n\nBelieve in your potential,\nAnd let your dreams take flight,\nFor you are bound for glory,\nIn every future sight.',
        'With every dawn that breaks,\nA new beginning starts,\nBringing endless chances,\nTo heal and mend our hearts.\n\nSo face each day with valor,\nAnd let your spirit free,\nFor boundless joy awaits you,\nAs far as eyes can see.'
      ]
    };
  },
  mounted() {
    this.initThree();
    this.initExtraThree();
  },
  methods: {
    initThree() {
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      const renderer = new THREE.WebGLRenderer();
      renderer.setSize(window.innerWidth, window.innerHeight);
      document.getElementById('three-container').appendChild(renderer.domElement);

      // Create a cube with changing color
      const geometry = new THREE.BoxGeometry();
      const material = new THREE.MeshBasicMaterial();
      const cube = new THREE.Mesh(geometry, material);
      scene.add(cube);

      camera.position.z = 5;

      // Animation loop
      const animate = function () {
        requestAnimationFrame(animate);

        // Rotate the cube
        cube.rotation.x += 0.01;
        cube.rotation.y += 0.01;

        // Change color every second
        material.color.setHSL(Math.random(), 10, 10);

        renderer.render(scene, camera);
      };
      animate();

      // Handle window resize
      window.addEventListener('resize', () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      });
    },
    initExtraThree() {
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
      const renderer = new THREE.WebGLRenderer();
      renderer.setSize(window.innerWidth, window.innerHeight);
      document.getElementById('three-container-extra').appendChild(renderer.domElement);

      // Create a moving object
      const geometry = new THREE.BoxGeometry();
      const material = new THREE.MeshBasicMaterial();
      const movingObject = new THREE.Mesh(geometry, material);
      scene.add(movingObject);

      camera.position.z = 5;

      // Movement variables
      let moveDirection = 0;
      const speed = 0.1;

      // Animation loop
      const animate = function () {
        requestAnimationFrame(animate);

        // Move the object
        movingObject.position.x += moveDirection * speed;

        // Wrap around the screen
        if (movingObject.position.x > window.innerWidth / 2) {
          movingObject.position.x = -window.innerWidth / 2;
        } else if (movingObject.position.x < -window.innerWidth / 2) {
          movingObject.position.x = window.innerWidth / 2;
        }

        renderer.render(scene, camera);
      };
      animate();

      // Handle window resize
      window.addEventListener('resize', () => {
        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(window.innerWidth, window.innerHeight);
      });
    },
    startGame() {
      this.showGame = true;
      this.feedbackMessage = '';
      this.showPoem = false;
      this.showInstructions = true;
      this.shuffledLetters = this.shuffleArray([...this.letters]);
      this.puzzlePositions = this.shuffledLetters.map((_, index) => ({
        left: (index % 3) * 100,
        top: Math.floor(index / 3) * 100,
      }));

      // Hide instructions after 3 seconds
      setTimeout(() => {
        this.showInstructions = false;
      }, 3000);
    },
    closeGame() {
      this.showGame = false;
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    startDrag(event, index) {
      this.isDragging = true;
      this.dragStartIndex = index;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.endDrag);
    },
    drag(event) {
      if (this.isDragging) {
        const element = document.querySelectorAll('.puzzle-piece')[this.dragStartIndex];
        element.style.left = `${event.clientX - 50}px`;
        element.style.top = `${event.clientY - 50}px`;
      }
    },
    endDrag() {
      if (this.isDragging) {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.drag);
        document.removeEventListener('mouseup', this.endDrag);

        // Snap the piece to the nearest position
        const element = document.querySelectorAll('.puzzle-piece')[this.dragStartIndex];
        const nearestPos = this.puzzlePositions.find(pos => Math.abs(pos.left - parseInt(element.style.left)) < 50 && Math.abs(pos.top - parseInt(element.style.top)) < 50);

        if (nearestPos) {
          const nearestIndex = this.puzzlePositions.indexOf(nearestPos);
          [this.shuffledLetters[this.dragStartIndex], this.shuffledLetters[nearestIndex]] = [this.shuffledLetters[nearestIndex], this.shuffledLetters[this.dragStartIndex]];
        }

        // Update positions
        this.puzzlePositions = this.shuffledLetters.map((_, index) => ({
          left: (index % 3) * 100,
          top: Math.floor(index / 3) * 100,
        }));
      }
    },
    checkSolution() {
      if (JSON.stringify(this.shuffledLetters) === JSON.stringify(this.letters)) {
        this.feedbackMessage = 'Congratulations! You solved the puzzle!';
        this.showPoem = true;
        this.poem = this.getRandomPoem();
      } else {
        this.feedbackMessage = 'Keep trying!';
      }
    },
    getRandomPoem() {
      return this.poems[Math.floor(Math.random() * this.poems.length)];
    },
    closePoem() {
      this.showPoem = false;
    },
  }
};
</script>

<style>
.three-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #000;
  z-index: -1;
}

.three-container-extra {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #000;
  z-index: -1;
}

.home-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #fff;
}

.title {
  font-size: 3rem;
  margin-bottom: 20px;
}

.intro {
  font-size: 1.5rem;
  margin-bottom: 30px;
}

.game-button {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.nav-button {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.game-area {
  position: relative;
  width: 300px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  color: #fff;
  background: white;
  border-radius: 10px;
}

.puzzle {
  display: grid;
  grid-template-columns: repeat(3, 100px);
  grid-template-rows: repeat(3, 100px);
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.puzzle-piece {
  width: 100px;
  height: 100px;
  background-color: #007bff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  color: white;
  cursor: pointer;
  position: absolute;
}

.check-button {
  background-color: #28a745;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 20px 2px;
  cursor: pointer;
}

.feedback-message {
  font-size: 1.2rem;
  margin-top: 10px;
}

.poem-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.poem-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  color: #333;
}

.close-button, .close-game-button {
  background-color: #dc3545;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}

.instructions {
  margin-bottom: 10px;
  font-style: italic;
}

.puzzle {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10px;
}

.puzzle-piece {
  width: 100px;
  height: 100px;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin: 5px;
  cursor: grab;
}

.check-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.feedback-message {
  margin-top: 10px;
  font-size: 18px;
  color: #007bff;
}

.poem-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}

.poem-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
}

.close-button, .close-game-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.blur {
  filter: blur(5px);
}

.nav-button {
  margin: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

</style>

